export const EMPTY_FRAGMENT = new DocumentFragment()
